// ============================================================
// AppBarChart Component
// ============================================================

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
} from 'recharts';
import { tokens } from '@/theme/tokens';
import { Box, Typography } from '@mui/material';

export function AppBarChart({ data, xAxisKey, dataKey, color = tokens.colors.primary.main, formatValue }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 10, right: 10, left: 20, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={tokens.colors.border} />
        <XAxis 
          dataKey={xAxisKey} 
          axisLine={false} 
          tickLine={false} 
          tick={{ fontSize: 11, fill: tokens.colors.text.secondary }}
          dy={10}
          dx={-10}
          interval={0}
          angle={-45}
          textAnchor="end"
          height={60}
        />
        <YAxis 
          axisLine={false} 
          tickLine={false} 
          tick={{ fontSize: 12, fill: tokens.colors.text.secondary }}
          tickFormatter={(value) => formatValue ? formatValue(value) : value}
          width={80}
        />
        <RechartsTooltip
          cursor={{ fill: `${color}10` }}
          content={({ active, payload, label }) => {
            if (active && payload && payload.length) {
              const rowData = payload[0].payload;
              return (
                <Box sx={{
                  backgroundColor: tokens.colors.card,
                  p: 1.5,
                  borderRadius: tokens.radius.md,
                  border: `1px solid ${tokens.colors.border}`,
                  boxShadow: tokens.shadows.md,
                }}>
                  <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>{label}</Typography>
                  {payload.map((entry, index) => (
                    <Typography key={index} variant="body2" sx={{ color: entry.color, fontWeight: 500 }}>
                      Amount: {formatValue ? formatValue(entry.value) : entry.value}
                    </Typography>
                  ))}
                  {rowData.count !== undefined && (
                    <Typography variant="body2" sx={{ color: tokens.colors.text.secondary, mt: 0.5 }}>
                      Count: {rowData.count} {rowData.count === 1 ? 'Student' : 'Students'}
                    </Typography>
                  )}
                </Box>
              );
            }
            return null;
          }}
        />
        <Bar 
          dataKey={dataKey} 
          fill={color} 
          radius={[4, 4, 0, 0]} 
          maxBarSize={50}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
